import { type ReactNode } from 'react';

type DesktopSizeOptions = 'default' | 'large';
export type DesktopSizing = Record<DesktopSizeOptions, { heightRatio: number; width: string }>;

export const desktopSizes: DesktopSizing = {
	default: { heightRatio: 0.8, width: '560px' },
	large: { heightRatio: 0.9, width: '860px' }
};

export type BaseModalProps = {
	background?: string;
	child?: ReactNode;
	closeIconColor?: string;
	closeModal?: () => void;
	detached?: boolean;
	footer?: ReactNode;
	/** Makes modal display with max height regardless of the content it has. */
	fullHeight?: boolean;
	inView?: boolean;
	isClosable?: boolean;
	/** For mobile & tablet only */
	isDraggable?: boolean;
	justClosed?: boolean;
	/** For desktop only */
	size?: DesktopSizeOptions;
	/** Sticky sub header */
	subHeader?: ReactNode;
	testID?: string;
};

export type DesktopModalWrapperProps = BaseModalProps;

export type MobileModalWrapperProps = BaseModalProps;
